import ElementForm from './container';

export default ElementForm;



// WEBPACK FOOTER //
// ./src/routes/ElementForm/index.js